/**
 * Sidebar — デスクトップ左サイドバー (#23: Desktop >=768px のみ表示)
 * モバイルでは非表示。アイコンはインライン SVG (#45)。
 */

import { NavLink } from 'react-router-dom'
import Icon from './Icon'

interface NavItem {
  to: string
  label: string
  icon: React.ComponentProps<typeof Icon>['name']
}

const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'ホーム', icon: 'home' },
  { to: '/study', label: '学習', icon: 'book' },
  { to: '/practice', label: '演習', icon: 'pencil' },
  { to: '/review', label: '復習', icon: 'refresh' },
  { to: '/mock-exam', label: '模擬試験', icon: 'clipboard' },
  { to: '/stats', label: '成績', icon: 'chart' },
]

export default function Sidebar() {
  return (
    <aside
      aria-label="サイドナビゲーション"
      className="fixed inset-y-0 left-0 z-50 flex w-[220px] flex-col border-r border-border bg-surface py-6"
    >
      <div className="mb-4 border-b border-border px-5 pb-6">
        <div className="text-[15px] font-bold tracking-tight text-text-primary">衛生管理者対策</div>
        <div className="mt-0.5 text-xs text-text-muted">試験対策アプリ</div>
      </div>
      <nav className="flex flex-col gap-0.5 px-2">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              [
                'flex items-center gap-3 rounded-md px-3 py-2.5 text-sm transition-colors duration-fast ease-smooth',
                isActive
                  ? 'bg-accent-subtle font-bold text-accent'
                  : 'font-medium text-text-secondary hover:bg-surface-alt hover:text-text-primary',
              ].join(' ')
            }
          >
            <Icon name={item.icon} size={18} />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  )
}
